export default (node) => {
  /**
   * Data + elements
   */
  const mobileMenu = node.querySelector('[data-component="mobileMenu"]');
  const mobileMenuButton = node.querySelector('[data-mobile-menu-button]');
  const hamburgerIcons = node.querySelectorAll('[data-hamburger-icon]');
  const searchButton = node.querySelectorAll('[data-search-button]');
  const languagePopup = node.querySelectorAll('[data-language-popup]');
  const searchComponent = document.querySelector(
    '[data-component="searchComponent"]'
  );
  const shoppingCart = node.querySelector('[data-shopping-cart-button]');
  const customerButton = node.querySelector('[data-customer-button]');

  const allSimpleLinkSections = document.querySelectorAll(
    '[data-simple-look-link="true"]'
  );

  /**
   * Functions
   */

  function toggleMenu() {
    mobileMenu.classList.toggle('hidden');
    mobileMenu.classList.toggle('flex');

    hamburgerIcons.forEach((el) => {
      el.classList.toggle('hidden');
    });
  }

  const toggleSearch = () => {
    document.dispatchEvent(new CustomEvent('search:open'));
  };

  const openCustomerMenu = () => {
    document.dispatchEvent(new CustomEvent('customer-menu:open'));
  };

  /** this function leave only 1 see more button for the section simple look
   *  because this section is using block to display the products
   *  otherwise we would need to add the product picker inside the general settings of the section
   *  limitating the number of products to show
   */

  const checkSeeMoreButtons = () => {
    // count the number of wrappers, if there are more than 3, hide the rest and leave only 1 see more button
    if (allSimpleLinkSections && allSimpleLinkSections.length > 3) {
      allSimpleLinkSections.forEach((wrapper, index) => {
        if (index > 2) {
          wrapper.classList.add('hidden');
        }
        const buttonSection = wrapper.querySelector(
          '[data-see-more-simple-look-wrapper]'
        );
        if (buttonSection) {
          if (index === 2) {
            buttonSection.classList.remove('hidden');
            buttonSection.addEventListener('click', showAllSimpleLookProducts);
          } else {
            buttonSection.classList.add('hidden');
          }
        }
      });
    }
  };

  const showAllSimpleLookProducts = (e) => {
    if (allSimpleLinkSections) {
      allSimpleLinkSections.forEach((section) => {
        section.classList.remove('hidden');
      });
      e.currentTarget.remove();
    }
  };

  /**
   * Init
   */
  const init = () => {
    mobileMenuButton.addEventListener('click', toggleMenu);
    if (searchButton) {
      searchButton.forEach((el) => {
        el.addEventListener('click', toggleSearch);
      });
    }
    if (shoppingCart) {
      shoppingCart.addEventListener('click', (e) => {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
    }
    if (customerButton) {
      customerButton.addEventListener('click', openCustomerMenu);
    }
    checkSeeMoreButtons();

    if (languagePopup) {
      languagePopup.forEach((el) => {
        el.addEventListener('click', () => {
          document.dispatchEvent(new CustomEvent('language-popup:open'));
        });
      });
    }
  };

  init();
};
